import API from './API'
import { axios } from '@/request/request.js'

export function codelogin(data) {
    return axios.post(`${API.codelogin}`,data)
}
export function login(data) {
    return axios.post(`${API.login}`,data)
}
export function getIpCountry() {
    return axios.get(`${API.getIpCountry}`)
}

export function checkToken(data) {
    return axios.post(`${API.checkToken}`,data)
}
export function logoutToken() {
    return axios.get(`${API.logoutToken}`)
}
export function googlelogin(data) {
    return axios.post(`${API.googlelogin}`,data)
}
export function facebooklogin(data) {
    return axios.post(`${API.facebooklogin}`,data)
}


//用户表
export function updateUserById(data) {
    return axios.put(`${API.updateUserById}`,data)
}
export function getUserByid(data) {
    return axios.get(`${API.getUserById}?id=`+data)
}
export function getUserIntegral() {
    return axios.get(`${API.getUserIntegral}`)
}

export function getLoginCode(data,flag) {
    return axios.get(`${API.getLoginCode}?email=`+data+`&flag=`+flag)
}
export function getRegisterCode(data) {
    return axios.get(`${API.getRegisterCode}?email=`+data)
}
export function register(data) {
    return axios.post(`${API.register}`,data)
}
export function getResetPwdCode(data) {
    return axios.get(`${API.getResetPwdCode}?email=`+data)
}
export function updatePwd(data) {
    return axios.put(`${API.updatePwd}`,data)
}

export function getCouponInfo(){
    return axios.get(`${API.getCouponInfo}`)
}


export function downFile(url,parameter){
    console.log(parameter)
    return axios({
        url: url,
        params: parameter,
        method:'get' ,
        responseType: 'blob'
    })
}

export function uploadFile(data) {
    return axios.post(`${API.uploadFile}`,data)
}
export function toluckdraw(data) {
    return axios.get(`${API.luckdraw}?position=`+data)
}
export function insertMessage(data) {
    return axios.post(`${API.insertMessage}`,data)
}
export function getMessageByUserid(data) {
    return axios.get(`${API.getMessageByUserid}?userid=`+data)
}
export function getUserexcodeByUserid(data) {
    return axios.get(`${API.getUserexcodeByUserid}?remark=`+data)
}
export function getUserExcode(data){
    return axios.get(`${API.getUserexcodeByUserid}?${data}`)
}
export function exchange(data) {
    return axios.post(`${API.exchange}`,data)
}
export function marketexchange(data) {
    return axios.post(`${API.marketexchange}`,data)
}

export function getHelptypeAll() {
    return axios.get(`${API.getHelptypeAll}`)
}
export function getHelpdetailByid(id) {
    return axios.get(`${API.getHelpdetailList}?id=`+id)
}
export function getWorkOrderList(data){
    return axios.get(`${API.getWorkOrderList}?${data}`)
}
export function getWordertypeAll() {
    return axios.get(`${API.getWordertypeAll}`)
}
export function insertWorkorder(data) {
    return axios.post(`${API.insertWorkorder}`,data)
}
export function updateWorkorder(data) {
    return axios.put(`${API.updateWorkorder}`,data)
}
export function getTicketListByUserId() {
    return axios.get(`${API.getTicketListByUserId}`)
}
export function carinforesetpwd(data) {
    return axios.post(`${API.carinforesetpwd}`,data)
}
export function carinforeminder(data) {
    return axios.post(`${API.carinforeminder}?carid=`+data)
}

export function getGoodsspuAll() {
    return axios.get(`${API.getGoodsspuAll}`)
}
export function getGoodsspuById(data) {
    return axios.get(`${API.getGoodsspuById}?id=`+data)
}
export function orderSubmit(data) {
    return axios.post(`${API.orderSubmit}`,data)
}
export function payssion(data) {
    return axios.post(`${API.payssion}`,data)
}
export function stripe(data) {
    return axios.post(`${API.stripe}`,data)
}

export function orderRenew(data) {
    return axios.post(`${API.orderRenew}`,data)
}

export function calprice(data) {
    return axios.post(`${API.calprice}`,data)
}
export function userAllTicket(data) {
    return axios.get(`${API.userAllTicket}?userid=`+data)
}
export function getCountryinfoAll() {
    return axios.get(`${API.getCountryinfoAll}`)
}
export function getProvinceAll(data) {
    return axios.get(`${API.getProvinceAll}?code=`+data+"-")
}
export function insertWithdrawal(data) {
    return axios.post(`${API.insertWithdrawal}`,data)
}
export function getWithdrawalList(data){
    return axios.get(`${API.getWithdrawalList}?${data}`)
}
export function getPayAddressByUserId(data) {
    return axios.get(`${API.getPayAddressByUserId}?userid=`+data)
}
export function paytypeall() {
    return axios.get(`${API.paytypeall}`)
}

//wangchuang modifyed
export function getTicketList(excode,userid){
	return axios.get(`${API.getTicketList}/`+excode+'/'+userid)
}


// 请求获取链接
export function getnfcodelink(data) {
    return axios.get(`https://www.gosharegpt.com/mail/getLink?to=`+data)
}
// 只拿代码
export function getnfcode(data) {
    return axios.get(`https://www.gosharegpt.com/mail/getLinkcode?to=`+data)
}
// 油管工单
export function getToytbWorkorder(data) {
    return axios.post(`${API.getToytbWorkorder}`,data)
}
// 更新奈飞车票
export function updateUticket(data) {
    return axios.post(`${API.updateUticket}`,data)
}

export function getCommissionList(data){
    return axios.get(`${API.getCommissionList}?${data}`)
}

export function getUserOrderList(data){
    return axios.get(`${API.getUserOrderList}?${data}`)
}
//退款
export function submitrefund(data){
    return axios.post(`${API.submitrefund}`,data)
}

export function getOrderanalysisweeklydata(data){
    return axios.post(`${API.getOrderanalysisweeklydata}`,data)
}
export function getkolStatisData(data){
    return axios.post(`${API.getkolStatisData}`,data)
}
export function getOrderanalysisspu(data){
    return axios.post(`${API.orderanalysisspu}`,data)
}

export function getMessageList(data){
    return axios.get(`${API.getMessageList}?${data}`)
}

export function onlypay(data){
    return axios.post(`${API.onlypay}`,data)
}

//shareAI
export function getAiModelList(){
    return axios.get(`${API.getAiModelList}?size=100`)
}
export function getConversationsList(data){
    return axios.get(`${API.getConversationsList}?${data}`)
}
export function getMessageAIList(data){
    return axios.get(`${API.getMessageAIList}?${data}`)
}
export function deleteConversation(data){
    return axios.get(`${API.deleteConversation}?${data}`)
}
export function stopStream(data){
    return axios.get(`${API.stopStream}?${data}`)
}
export function updateTopFlag(data){
    return axios.post(`${API.updateTopFlag}`,data)
}
export function getUserActiveSubscription(){
    return axios.get(`${API.getUserActiveSubscription}`)
}



